import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';

export interface NavItem {
  label: string;
  route: string;
  icon: string;
  roles?: string[];
}

/**
 * Shared sidebar component for navigation
 * Content is provided via projection for portal-specific menus
 */
@Component({
  selector: 'lib-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  opened = input<boolean>(true);
  mode = input<'side' | 'over' | 'push'>('side');
  hasBackdrop = input<boolean>(false);
  
  closedChange = output<boolean>();
}

